import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export default function Layout({
  sideContent,
  title,
  mainContent,
  overflow,
  className,
}) {
  return (
    <>
      <div
        className={twMerge(
          clsx(
            'prose w-full max-w-[--page-content-w]',
            sideContent && 'grid grid-cols-[1fr,4fr]',
            className,
          ),
          className,
        )}
      >
        {sideContent && (
          <div
            className={clsx(
              'app-side-content bg-slate-600 flex flex-col text-white px-4 py-8 max-h-full rounded-bl-[--app-radius] box-border border-t border-t-white',
              overflow && overflow,
            )}
          >
            {sideContent}
          </div>
        )}
        <div
          className={clsx(
            'app-main-content flex flex-col items-center p-12 max-h-full overflow-auto relative bg-base-100 rounded-br-[--app-radius] border-r border-b border-[color:--border-color]',
            !sideContent && 'border-l rounded-bl-[--app-radius]',
          )}
        >
          {title && <h1>{title}</h1>}
          <div className="app-main-content-body flex flex-col w-full items-center -mt-6">
            {mainContent}
          </div>
        </div>
      </div>
    </>
  );
}
